import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import authReducer from "./AuthReducer"
import appReducer from "./AppReducer";
import evtReducer from "./EventReducer"
import plcReducer from "./PlaceReducer"
import usrReducer from "./UserReducer"
import rolReducer from "./RolReducer"
import ntfReducer from "./NotificationReducer"
import nvtReducer from "./NoveltyReducer"
import tagReducer from "./TagReducer"
import statsReducer from "./StatsReducer"

const rootReducer = combineReducers({
	form: formReducer,
	auth: authReducer,
	app: appReducer,
	evt: evtReducer,
	plc: plcReducer,
	usr: usrReducer,
	rol: rolReducer,
	ntf: ntfReducer,
	nvt: nvtReducer,
	tag: tagReducer,
	stats: statsReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js